"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaExCoeloAbilityHandler = exports.SignaExCoeloActorAbilityFactory = exports.SignaExCoeloAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class SignaExCoeloAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SignaExCoelo;
        this.__typeName = "SignaExCoelo";
    }
}
exports.SignaExCoeloAbilityArgs = SignaExCoeloAbilityArgs;
let SignaExCoeloActorAbilityFactory = class SignaExCoeloActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SignaExCoelo", "OneEnemies", 2);
    }
};
SignaExCoeloActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SignaExCoelo")
], SignaExCoeloActorAbilityFactory);
exports.SignaExCoeloActorAbilityFactory = SignaExCoeloActorAbilityFactory;
let SignaExCoeloAbilityHandler = class SignaExCoeloAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 80)
            ],
            projectileType: "LightningBolt",
            projectilePath: "line"
        });
    }
};
SignaExCoeloAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SignaExCoelo)
], SignaExCoeloAbilityHandler);
exports.SignaExCoeloAbilityHandler = SignaExCoeloAbilityHandler;
